import { DurationInput } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/infrastructureEventModal/durationInputs/DurationInput";
import { getInitialTimedDuration } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/infrastructureEventModal/durationInputs/initialDurationValues";
import { InfrastructureForm } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/formSchema";
import { FC, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "shared/components/Spor";

export const PlannedInfrastructureEvent: FC = () => {
  const { register, watch, setValue } = useFormContext<InfrastructureForm>();
  const durationType = watch("infrastructureForm.durations.type");

  const { t } = useTranslation();

  useEffect(() => {
    if (durationType === "OPEN_ENDED") {
      setValue("infrastructureForm.durations", getInitialTimedDuration());
    }
  }, [durationType]);

  return (
    <>
      <Input
        width="calc(50% - 12px)"
        label={t("I-sirk")}
        type="string"
        {...register("infrastructureForm.isirkId")}
      />
      <DurationInput />
    </>
  );
};
